import { Grid, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";
import { api } from "../../services/api";
import CardSys from "../cardSys";
import SelectEnterprise from "../selectEnterprise";
import InputName from "../generic/inputName";
import InputPassword from "../generic/inputPassword";
import ConfirmPassword from "../generic/inputConfirmPassword";
import { Box } from "@mui/system";
import SubTitlePages from "../generic/subTitlePages";
import ButtonSave from "../buttonSave";
import CloseButton from "../generic/closeButton";
import SwitchStatus from "../generic/switchStatus";
import CancelButton from "../generic/cancelButton";
import ButtonMaster from "../buttonMaster";
import SelectEnterpriseToUserAccess from "../selectEnterprisesToUserAccess";
import MultiSelectProfile from "../multiSelectProfiles";
import InputEmail from "../generic/inputEmail";
import MultiSelectGroup from "../multiSelectGroups";
import { useNavigate } from "react-router-dom";

export default function EditUser({ handleClose, userEdit, updateTable }) {
  const [id, setId] = useState(userEdit?.id);
  const [name, setName] = useState(userEdit?.name);
  const [email, setEmail] = useState(userEdit?.email);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [companyPermited, setCompanyPermited] = useState([])
  const [status, setStatus] = useState(userEdit?.status);
  const [master, setMaster] = useState(userEdit?.master);
  const [enterpriseSelected, setEnterpriseSelected] = useState("");
  const [groupsSelected, setGroupsSelected] = useState([]);
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate()
  const [masterButton,setMasterButton] = useState(userEdit?.master)
  

  const permissionUser = [];
  user?.permission?.map((el) => {
    if (el.name == "Usuários") {
      permissionUser.push(...el.permission);
    }
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    handleLoading(true);

    if (password !== confirmPassword) {
      handleToast(true, "error", "Senhas diferentes!");
      handleLoading(false);
      return;
    }
    
    if (!enterpriseSelected?.id) {
      handleToast(true, "error", "Selecione um cliente");
      handleLoading(false);
      return;
    }

    if (!companyPermited.length && (user?.id_client != 25886008 || !masterButton)) {
      handleToast(true, "error", "Selecione uma empresa de acesso");
      handleLoading(false);
      return;
    }

    const group = [];
    groupsSelected.map((el) => {
      group.push(el.id);
    });

    if (!enterpriseSelected?.id) {
      handleToast(true, "error", "Selecione um cliente")
      return
    }

    // const companyPermited2 = companyPermited.map(comp => {
    //   return comp?.id
    // })

    try {
      const { data } = await api({
        method: "put",
        url: "/user/" + id,
        data: {
          name,
          email,
          password,
          confirmPassword,
          companyPermited,
          id_client: enterpriseSelected?.id,
          name_client: enterpriseSelected?.name,
          groupsSelected: group,
          status: !!status ? 1 : 0,
          master: !!masterButton ? true : false
        },
      });
      handleToast(true, data.toast, data.message);
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
    updateTable()
  };

  useEffect(() => {
    getUser(userEdit?.id)
  }, [userEdit])

  const getUser = async (id) => {
    handleLoading(true);
    try {
      const { data } = await api({
        method: "get",
        url: "/user/" + id,
      });
      setName(data.name)
      setEmail(data.email)
      setStatus(data.status)
      setMaster(data.master)
      if (!!data.id_client && !!data?.name_client) {
        setEnterpriseSelected({ id: data.id_client, label: data?.name_client + " / " + data.id_client });
      }
      if (data?.companyPermited) {
        const companys = data.companyPermited.map((companys) => {
          let cnpj = companys.pes_cpfcnpj.length > 12 ? companys.pes_cpfcnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : companys.pes_cpfcnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");;
          return {
            id: companys.id,
            label: companys.label + ' / ' + cnpj,
            name: companys.label
          }
        })
        setCompanyPermited(companys);
      }
      setGroupsSelected(data.groups_user)
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <CardSys>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Grid container component="form" onSubmit={handleSubmit}>
            <Grid
              item
              sx={{ display: "flex" }}
              justifyContent="space-between"
              alignItems="center"
              xs={12}
            >
              <SubTitlePages sx={{ display: "flex" }}>
                <SubTitlePages sx={{ fontWeight: "bold", marginRight: "4px" }}>
                  Editar Usuário
                </SubTitlePages>
              </SubTitlePages>
              <CloseButton onClick={handleClose}></CloseButton>
            </Grid>
            <SelectEnterprise
              title="Empresa"
              value={enterpriseSelected}
              handleSelected={(elemento) => setEnterpriseSelected(elemento)}
            ></SelectEnterprise>
            <Grid item xs={12} sx={{ marginTop: "17px" }}>
              <InputName
                value={name}
                onChange={(event) => setName(event.target.value)}
                sx={{ background: "transparent" }}
                InputLabelProps={{
                  shrink: true,

                }}
              />
            <Grid item xs={12}  sx={{ marginTop: "17px" }}>
              <SelectEnterprise
              title="Empresas que o usuário tem acesso"
                multiple
                value={companyPermited}
                handleSelected={(elemento) => setCompanyPermited(elemento)}
              ></SelectEnterprise>
            </Grid>
            </Grid>
            
            <Grid item xs={12} sx={{ marginTop: "17px" }}>
              <MultiSelectGroup
               title="Perfil"
                value={groupsSelected}
                handleSelected={(elemento) => setGroupsSelected(elemento)}
              ></MultiSelectGroup>
            </Grid>
            <Grid item xs={12} sx={{ marginTop: "17px" }}>
              <InputPassword
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                sx={{ background: "transparent" }}
              />
            </Grid>

            <Grid item xs={12} sx={{ marginTop: "17px" }}>
              <ConfirmPassword
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                sx={{ background: "transparent" }}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: "17px" }}>
              <Typography>
                {email}
              </Typography>
              
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: "17px",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <SwitchStatus checked={!!status} onChange={() => setStatus(!status)}></SwitchStatus>
              { user?.id_client === 25886008 && <ButtonMaster 
              checked={!!master} 
              sx={{backgroundColor: masterButton ? "gold" : "light-gray"}} 
              onClick={()=> setMasterButton(!masterButton)} 
              onChange={() => {setMaster(!masterButton);console.log(master)}}>
              </ButtonMaster>}
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: "17px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CancelButton onClick={handleClose}></CancelButton>
              {!!permissionUser.find((el) => el.name == "Editar") ? (
                <ButtonSave  onClick={handleSubmit}>Salvar</ButtonSave>
              ) : null}
            </Grid>
          </Grid>
        </Box>
      </CardSys>
    </Box>
  );
}
